// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"11e2c09c","977":"670b9fab"}[chunkId] + ".chunk.js";
};